<template>
  <div style="overflow-x: hidden;">
    <b-card>
      <el-row :gutter="10">
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>申请人：</span>
            </div>
            <div class="showText">
              <span>{{ formData.salesPersonName }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>申请公司 ：</span>
            </div>
            <div class="showText">
              <span>{{ formData.expensePayerName }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>申请日期：</span>
            </div>
            <div class="showText">
              <span>{{ formData.requestDate }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>报销金额：</span>
            </div>
            <div class="showText">
              <span
                >{{ formData.v_currencyAmount }}
                {{ formData.v_currencyUnit }}</span
              >
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>备注说明：</span>
            </div>
            <div class="showText">
              <span
                >{{ formData.remark }}</span
              >
            </div>
          </div>
        </el-col>
      </el-row>
    </b-card>
    <b-card v-for="(item, index) in itemList" :key="index">
      <el-row :gutter="10">
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>起始城市：</span>
            </div>
            <div class="showText">
              <span
                >{{ item.departureCityName }} 至
                {{ item.destinationCityName }}</span
              >
              <el-tag
              class="ml-2"
              size="mini"
              :type="
                item.isSchedule === 'Y'
                  ? 'primary'
                  : item.isSchedule === 'N'
                  ? 'success'
                  : item.isSchedule === 'C'
                  ? 'danger'
                  : 'warning'
              "
            >
              {{ item.v_isSchedule }}
            </el-tag>
            </div>
            
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>行程日期：</span>
            </div>
            <div class="showText">
              <span
                >{{ item.scheduleStartDate }} 至
                {{ item.scheduleEndDate }}</span
              >
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>供应商：</span>
            </div>
            <div class="showText">
              <span>{{ item.scmName }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>客户：</span>
            </div>
            <div class="showText">
              <span>{{ item.custName }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>品牌：</span>
            </div>
            <div class="showText">
              <span>{{ item.brandName }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>出差原因：</span>
            </div>
            <div class="showText">
              <span>{{ item.tripReasons }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>拜访目的：</span>
            </div>
            <div class="showText">
              <span>{{ item.tripPurpose }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>对方人员：</span>
            </div>
            <div class="showText">
              <span>{{ item.visitPerson }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 24 }"
          :lg="{ span: 24 }"
        >
          <div class="d-flex mt-2">
            <div class="side-frame-success"></div>
            <div>
              <span style="font-size: 14px; color: #606266">
                报告内容
              </span>
            </div>
          </div>
          <el-card shadow="never">
            <div
              class="imageShow"
              v-viewer="{ movable: true }"
              v-html="item.reportDescription"
            ></div>
          </el-card>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 24 }"
          :lg="{ span: 24 }"
        >
          <div v-if="item.listDoc">
            <div class="d-flex mt-2">
              <div class="side-frame-warning"></div>
              <div>
                <span style="font-size: 14px; color: #606266">
                  相关文档
                </span>
              </div>
            </div>
            <ReportDocTable
              ref="ReportDocTable"
              :tableData="item.listDoc"
              class="mb-2"
            />
          </div>
        </el-col>
      </el-row>
    </b-card>
    <div class="mt-2 mb-2">
      <el-col :span="24"> </el-col>
    </div>
  </div>
</template>
<script>
import ReportDocTable from './report-doc-table.vue'
export default {
  name: 'opview-myTravelReimbursement-info',
  components: { ReportDocTable },
  data() {
    return {
      formData: {},
      itemList: []
    }
  },
  beforeCreate() {
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#f1f1f1;')
  },
  mounted() {
    if (this.$route.params.tripReimbursementCode) {
      let param = {
        tripReimbursementCode: this.$route.params.tripReimbursementCode
      }
      this.getData(param)
    }
  },
  methods: {
    getData(param) {
      this.$api.opaUserTripReimbursementDetailApi(param).then((res) => {
        this.formData = res.body
        this.itemList = this.formData.itemList
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.card {
  margin: 10px 10px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.showTitle {
  font-size: 14px;
  color: $color-text-sub;
  width: 100px;
}
.showText {
  font-size: 14px;
  color: $color-text-normal;
  width: 100%;
}
::v-deep .imageShow {
  p {
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
